import axiosClient from './axiosClient';
import { cachedRequest, invalidateRequest } from './requestCache';

const PROFILE_KEY = 'user:profile';
const PROFILE_TTL = 15 * 1000;

export const getUserProfile = async () => {
    try {
        return await cachedRequest(PROFILE_KEY, async () => {
            const response = await axiosClient.get('/v1/user/profile');
            return response.data;
        }, PROFILE_TTL);
    } catch (error) {
        return {
            success: false,
            error: true,
            message: error.message
        };
    }
};

export const updateUserProfile = async (profileData) => {
    try {
        const response = await axiosClient.post('/v1/user/profile/complete', profileData);
        invalidateRequest(PROFILE_KEY);
        return response.data;
    } catch (error) {
        return {
            success: false,
            error: true,
            message: error.response?.data?.data?.message || error.message
        };
    }
}; 

export const getUserNotifCount = async () => {
    try {
        const response = await axiosClient.get('v1/user/notifications/count')
        return response.data;
    }
    catch (error) {
        return {
            success: false,
            error: true,
            message: error.message
        }
    }
}

export const getUserNotifs = async () => {
    try {
        const response = await axiosClient.post('v1/user/notifications')
        return response.data;
    }
    catch (error) {
        return {
            success: false,
            error: true,
            message: error.message
        }
    }
}